<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'enroll', params: { id: id } }">{{ topTitle }}</router-link>
          <span>></span>
          <span>{{ "成绩" }}</span>
        </div>
        <div class="exam-box">
          <div class="title">{{ topTitle }}</div>

          <div class="result">
            <div class="result-item">
              <div class="result-item-title">{{ is_pass == 2 ? "正确数" : "考试得分" }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-content">{{ is_pass == 2 ? correct_quantity : scareNumber }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-title">{{ is_pass == 2 ? "总用时" : "考试用时" }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-content">{{ allTime }}</div>
            </div>
          </div>
          <div class="tips" v-if="is_pass == 1">恭喜您通过本次 {{ topTitle }}的考试</div>
          <div class="tips" v-else-if="is_pass == 0">很遗憾您没有通过考试 ，继续努力吧！</div>

          <!-- 练习题卡 -->
          <div v-if="is_pass == 2" style="margin: 0 auto;width: 54%;">
            <div class="card">
              <div class="card_body">
                <div class="card_tab"><i></i>实时成绩</div>
                <div class="eq" >
                  <div class="eq-item-r">正确</div>
                  <div class="eq-item-r fault">错误</div>
                  <div class="eq-item-r null">未答</div>
                  <div class="all">共{{ count }}题</div>
                </div>

                <div class="choice-list">
                  <div
                    class="list-item"
                    v-for="(item, index) in tika.length"
                    :key="index"
                    :class="tika[index] ? (tika[index] == 'yes' ? 'item-r' : tika[index] == 'no' ? 'item-f' : '') : ''"
                  >
                    {{ index + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 考试后未通过 -->
          <div class="tr-foot" v-if="is_pass == 0 && status == 0 && make_up_exam == 1">
            <div class="btn buy-btn" @click="toBK()">
              {{ "直接补考" }}
            </div>
          </div>
          <!-- 考试后通过 -->
          <div class="tr-foot" v-if="is_pass == 1">
            <div class="btn buy-btn" @click="toSee()">
              {{ "查看证书" }}
            </div>
          </div>
          <!-- 考试后未通过，但不能补考了 -->
          <div class="tr-foot" v-if="is_pass == 0 && status == 0 && make_up_exam !== 1">
            <div class="btn buy-btn" @click="toMySuccess()">
              {{ "查看成绩" }}
            </div>
          </div>
          <!-- 练习 -->
          <div class="tr-foot" v-if="is_pass == 2">
            <div class="btn buy-btn" @click="toEdit(1)">
              {{ "全部解析" }}
            </div>
            <div class="btn buy-btn" @click="toEdit()">
              {{ "再做一次" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 证书pop-->
    <el-dialog title="证书" :visible.sync="showPop" width="30%">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column; font-size: 16px">
        <img style="width: 100%; height: auto" :src="imageUrl" alt="" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showPop = false">取 消</el-button>
        <el-button type="primary" @click="downloadIamge(imageUrl, '证书')" :loading="load">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topTitle: "详情",
      correct_quantity: 0,
      errors_quantity: 0,
      count: 0,
      tika: [],
      allTime: 0,
      is_pass: 0, //0：考试未通过；1：考试通过；2：章节练习完成
      id: "",
      status: 0,
      orderId: "",
      newList: [],
      scareNumber: 0,
      make_up_exam: 1,
      class_id: 0,
      showPop: false,
      load: false,
      imageUrl: "",
    };
  },
  mounted() {
    this.topTitle = sessionStorage.getItem("examTitle");
    let data = this.$route.params.datas;
    if (data == "no") {
      data = localStorage.getItem("exercise");
    }
    let option = JSON.parse(data);
    console.log("本页参数==", option);
    this.id = option.id;
    this.orderId = option.order_id;
    this.correct_quantity = option.correct_quantity;
    this.errors_quantity = option.errors_quantity;
    this.tika = option.tika;
    this.is_pass = option.is_pass;
    let tims = this.dateformat(option.allTime);
    this.allTime = tims;
    this.type_id = option.type_id;
    this.scareNumber = option.scareNumber;
    if (option.tika) {
      this.count = option.tika.length;
    }
    if (option.newList) {
      this.newList = option.newList;
    }
    if (option.make_up_exam) {
      this.make_up_exam = option.make_up_exam;
    }
    if (option.class_id) {
      this.class_id = option.class_id;
    }
  },
  methods: {
    downloadIamge(imgsrc, name) {
      this.load = true;
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossorigin", "anonymous");

      // console.log("当前图片",image);
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
      this.load = false;
    },
    // 重做or解析
    toEdit(e) {
      let id = JSON.parse(sessionStorage.getItem("nowPageData"));
      if (e == 1) {
        // 解析
        localStorage.setItem("newList", JSON.stringify(this.newList));
        localStorage.setItem("tika", JSON.stringify(this.tika));
        const { href } = this.$router.resolve({
          name: "startChapterExercise",
          params: { id: id, type_id: this.type_id, title: this.topTitle, openTipCard: true },
        });
        // console.log(id,href);
        window.open(href, "_blank");
        window.close();
      } else {
        // let datas = this.newList;
        const { href } = this.$router.resolve({
          name: "startChapterExercise",
          params: { id: id, type_id: this.type_id, title: this.topTitle, openTipCard: false },
        });
        window.open(href, "_blank");
        window.close();
      }
    },
    // 补考
    toBK() {
      let data = {
        plan_id: this.id,
        payment_code: "wechatpay",
        make_up_exam: 1,
      };
      this.$api.examPay(data).then((res) => {
        if (res.status) {
          if (res.data.amount * 1) {
            this.$router.push({
              name: "gamePay",
              params: { order_id: res.data.order_id, type: 10, bk: true ,title:this.topTitle},
            });
          } else {
            this.$router.push({
              name: "enroll",
              params: { id: this.id },
            });
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查看证书
    toSee() {
      // this.$router({
      //     name: 'examCertificate',
      //     params: { plan_id: this.id}
      // })
      this.$api
        .certificate({
          plan_id: this.id,
        })
        .then((res) => {
          if (res.status) {
            this.imageUrl = res.data;
            this.showPop = true;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    dateformat(value) {
      let result = parseInt(value);

      let h = Math.floor(result / 3600) < 10 ? "0" + Math.floor(result / 3600) : Math.floor(result / 3600);
      let m = Math.floor((result / 60) % 60) < 10 ? "0" + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
      let s = Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);
      result = `${h}:${m}:${s}`;

      return result;
    },
    PrefixInteger(num, length) {
      return (Array(length).join("0") + num).slice(-length);
    },
    toMySuccess() {
      this.$router.push({
        name: "mySuccess",
        params: { id: this.id, title: this.topTitle },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .result {
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    margin-bottom: 30px;
    .result-item {
      width: 160px;
      height: 80px;
      .result-item-title {
        width: 100%;
        height: 100%;
        line-height: 80px;
        background: rgba(242, 241, 241, 1);
        color: #333333;
      }
      .result-item-content {
        width: 100%;
        height: 100%;
        line-height: 80px;
        border: 1px solid rgba(242, 241, 241, 1);
        background: rgba(255, 255, 255, 1);
        color: red;
      }
    }
  }
  .tips {
    width: 100%;
    height: 22px;
    line-height: 22px;
    text-align: center;
    margin-bottom: 48px;
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.card {
  padding: 26px 20px 23px;
  border-radius: 10px;
  margin: 0 0 20px;
  background: #f2f1f1;
  .card_body {
    .card_tab {
      width: 100%;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(49, 44, 44, 1);
      line-height: 22px;
      margin-bottom: 27px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      i {
        width: 4px;
        height: 16px;
        display: inline-block;
        background-color: rgba(231, 68, 47, 1);
        margin-right: 8px;
      }
    }
    .person-con {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 80%;
      height: 60px;

      .icon-bg {
        .icon {
          width: 60px;
          height: 60px;
          display: inline-block;
          border-radius: 50%;
          box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
          border: 1px solid white;
          margin-right: -12px;
        }
      }
    }

    .btn_arrow {
      width: 80px;
      height: 32px;
      background-color: #f2f3f3;
      border-radius: 100px;
      color: #808080;
      font-size: 10px;
      text-align: center;
      line-height: 32px;
    }
    .btn {
      width: 95%;
      height: 52px;
      background-color: rgba(250, 250, 250, 1);
      color: rgba(49, 44, 44, 1);
      font-size: 14px;
      line-height: 52px;
      text-align: left;
      padding-left: 18px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
    .btns {
      display: flex;
      justify-content: space-between;

      .defaultBtn {
        width: 165px;
        height: 52px;
        background-color: rgba(250, 250, 250, 1);
        color: rgba(49, 44, 44, 1);
        font-size: 14px;
        line-height: 52px;
        text-align: center;
      }
    }
    .pic_bg {
      width: 100%;
      height: 150px;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      border: 1px solid rgba(242, 241, 241, 1);
      margin-bottom: 20px;
    }
    .product-name {
      height: 20px;
      font-size: 14px;
      text-align: left;
      line-height: 20px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    .product-icon {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .icon {
          width: 26px;
          height: 26px;
          display: block;
          margin-bottom: 9px;
        }
      }
    }

    .img-zxc {
      width: 100%;
      height: auto;
      position: relative;
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 20px;

      img {
        max-width: 100% !important;
        height: auto;
      }
      p {
        width: 100%;

        img {
          max-width: 100%;
        }
      }
    }
  }
}

.eq {
  position: relative;
  width: 100%;
  height: 20px;
  display: flex;
  justify-items: start;
  color: rgb(108, 122, 133);
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  margin: 18px 0 13px;

  .eq-item-r {
    position: relative;
    margin-right: 34px;
    width: 57px;
    padding-left: 23px;

    &::after {
      width: 18px;
      height: 18px;
      display: inline-block;
      position: absolute;
      content: "";
      left: 0;
      top: 1px;
      border-radius: 50%;
      background-color: rgb(236, 253, 255);
      border: 1px solid rgb(12, 230, 255);
    }
  }

  .fault {
    &::after {
      background-color: rgb(255, 228, 227);
      border: 1px solid rgb(254, 71, 68);
    }
  }

  .null {
    &::after {
      background-color: rgb(243, 244, 245);
      border: 1px solid rgb(181, 188, 193);
    }
  }

  .all {
    position: absolute;
    right: 0;
  }
}

.choice-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .list-item {
    width: 39px;
    height: 39px;
    margin: 9px;
    border-radius: 50%;
    font-size: 18px;
    line-height: 39px;
    text-align: center;
    color: rgb(181, 188, 193);
    background-color: rgb(243, 244, 245);
    border: 1px solid rgb(181, 188, 193);

    &:nth-of-type(10n + 10) {
      margin-right: 0;
    }
  }

  .item-r {
    background-color: rgb(236, 253, 255) !important;
    border: 1px solid rgb(12, 230, 255) !important;
  }

  .item-f {
    background-color: rgb(255, 228, 227) !important;
    border: 1px solid rgb(254, 71, 68) !important;
  }
}
</style>
